export const TERMS_CONDITIONS = [
  {
    termTitle: "Eligibility",
    subTerms: [
      "Any student who are visiting the stall of Indira Gandhi Centre for Career Development (IGCCD) situated at Mysore Dasara Location",
      "Each Student should register providing valid identification proof"
    ]
  },
  {
    termTitle: "Sign-In",
    subTerms: [
      "Each Student should sign in providing valid mobile number OTP will be generated",
      "Name, Mobile number and Adress are mandatory fields"
    ]
  },
  {
    termTitle: "Participation",
    subTerms: [
      "Participant should have stable internet connection and access to a computer or Mobile",
      "Quiz will need to be attend through the Link provided on the specific date and time",
      "Link will be shared via message or email"
    ]
  },
  {
    termTitle: "Question",
    subTerms: ["The questions will consist of various national and international news, as well as current affairs."]
  },
  {
    termTitle: "Winners ",
    subTerms: [
      "Winners will be selected based on certain criteria :",
      "*Fastest finger first",
      "*Highest Score",
      "*All questions to be attended",
      "*Conditions apply"
    ]
  }
];
